module.exports = __webpack_public_path__ + "res/28-img_business_bg.a0fc34246a55de9fa61c3636f63adee1.png";